<template>
            <v-dialog v-model="visFl" scrollable @keydown.esc="close" @keydown.enter="doAct" max-width="500">
               <v-card>
                <v-card-title class="headline">
                    <span v-if='isNew'>{{ $t( 'message.create_prop_title' ) }}</span>
                    <span v-else>{{ $t( 'message.edit_prop_title' ) }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-select :label="$t( 'message.create_sys_prop_type' )" required item-text="name" item-value="urn" v-model="propType" 
                            :items="types" :rules="[v => !!v || $t( 'message.value_required' )]" @change="updateRoles()" :readonly="!canDel">
                        </v-select>
                        
                        <v-select :label="$t( 'message.create_sys_prop_role' )" required v-model="propRole" 
                               :rules="[v => !!v || $t( 'message.value_required' )]" no-data-text=""
                              :menu-props="{ closeOnContentClick: true }" hide-selected :items="rolesList" 
                              item-text="name" item-value="urn" :readonly="!canDel">
                            <template v-slot:prepend-item>
                                <v-treeview :items="roles" style="font-size: 14px;" :active="treeActive"
                                    activatable item-key="urn" item-text="name" item-children="subtypes" dense 
                                    transition @update:active="selectRole">
                                </v-treeview>
                            </template>
                        </v-select>

                        <v-select :label="$t( 'message.create_sys_prop_subj' )" required item-text="txt" item-value="val" v-model="propSubj" 
                            :items="subjects" :rules="[v => !!v || $t( 'message.value_required' )]" :readonly="!canDel"></v-select>

                        <v-text-field :label="$t( 'message.create_sys_prop_name' )" required v-model="propName" :readonly="!canDel"
                                :rules="[ v => !!v || $t( 'message.value_required' ), 
                                          v => $utils.checkSymbols( v ) || $t( 'message.wrong_symbols' ) ]"></v-text-field>

                        <v-text-field :label="$t( 'message.create_sys_prop_urn' )" v-model="propUrn" disabled v-if="!isNew">
                            </v-text-field>

                        <v-textarea :label="$t( 'message.create_sys_prop_descr' )" v-model="propDescr"></v-textarea>
                                                
                        <v-checkbox :label="$t( 'message.create_sys_prop_exlusive' )" v-model="exlusive" :disabled="!canDel"></v-checkbox>
                        <v-checkbox :label="$t( 'message.create_sys_prop_mandatory' )" v-model="mandatory" :disabled="!canDel"></v-checkbox>
                        <v-checkbox :label="$t( 'message.create_sys_prop_hidden' )" v-model="hidden"></v-checkbox>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn id="createPropOk" color="green darken-1" text :disabled="!valid" @click.native="doAct()">{{ $t( 'message.ok_btn' ) }}</v-btn>
                    <v-btn id="createPropClose" color="green darken-1" text @click.native="close()">{{ $t( 'message.cancel_btn' ) }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>   
</template>

<script>
    
import Vue from 'vue'
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'createSysProp',
  data () 
  {
    return {
        visFl: false,
        propUrn: null,
        propDescr: null,
        propName: null,
        propType: null,
        propRole: null,
        propSubj: null,
        hidden: false,
        mandatory: false,
        exlusive: false,
        isNew: false,
        canDel: true,
        types: [],
        roles: [],
        subjects: [],
        typeRoleMap: {},
        resolve: null,
        reject: null,
        valid: true,
        treeActive: [],
        rolesList: []
    };
  },
  computed: {
  },
  components: {
  },
  methods: {
      open( prop, rdlName, typeRoleMap )
      {
          console.log( prop, rdlName );
          let self = this;
          this.typeRoleMap = typeRoleMap;
          let obj = rdlName === 'urn:rdl:epm-std:Document_content_type' ? 'DOCUMENT' : 'BREAKDOWN_ELEMENT';
          this.isNew = !prop;
          this.canDel = prop ? prop.canDel : true;
          this.propUrn = prop ? prop.property_urn : null;
          this.propName = prop ? prop.name : null;
          this.propDescr = prop ? prop.description : null;
          this.propType = prop ? prop.assignment_type : null;
          this.propRole = prop ? prop.role_urn : null;
          this.propSubj = prop ? prop.subject : null;
          
          this.mandatory = prop ? !prop.tags.includes( 'OPTIONAL' ) : false;
          this.hidden = prop ? prop.tags.includes( 'HIDDEN' ) : false;
          this.exlusive = prop ? prop.tags.includes( 'EXCLUSIVE' ) : false;
          
          conf.listAssignmentSubjects( obj )
                .then( data =>
          {
                ( data || [] ).forEach( el => 
                {
                    self.subjects.push( { val: el, txt: el } );
                });
          } )
                .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          }); 

          conf.listAssignmentTypes()
                .then( data =>
          {
                self.types = data;
                self.updateRoles( this.propType );
                self.selectRole( [ this.propRole ] );
          } )
                .catch( ( err ) =>
          {
              self.$eventBus.$emit( 'queryError', err );
          }); 

          this.visFl = true;
          
          return new Promise( ( resolve, reject ) => 
          {
            this.resolve = resolve;
            this.reject = reject;
          });
      },
      selectRole( elems )
      {
      //  console.log( elems );
          this.rolesList = [ { urn: elems[ 0 ], name: this.typeRoleMap[ elems[ 0 ] ] || this.$utils.clearType( elems[ 0 ] ) } ];
          this.propRole = elems[ 0 ];
      },
      updateRoles()
      {
       //     console.log( this.propType );
            for( let i = 0; i < this.types.length; i++ )
            {
                if( this.types[ i ].urn === this.propType )
                {
                    this.roles = [ this.types[ i ].roles_branch ];
                    return;
                }
            }
      },
      close()
      {
          this.visFl = false;
          this.reject();
      },
      doAct()
      {
          if( this.$refs.form.validate() )
          {
              this.visFl = false;
              
              this.resolve( { type: this.propType, descr: this.propDescr, subj: this.propSubj, 
                  role: this.propRole, name: this.propName, hidden: this.hidden, 
                  urn: this.propUrn, mandatory: this.mandatory, exlusive: this.exlusive } );
          }
      }
    }
}
</script>

<style scoped>
        
    .v-list-item
    {
        display: none !important;
    }
</style>

